import z from 'zod'
import {
  firestoreWriteTimestamp,
  nullSafeOptionalBoolean,
  nullSafeOptionalFirestoreTimestamp,
} from '../shared/schema'

export const schema = z.object({
  sectionId: z.string(),
  assignmentId: z.string(),
  roomId: z.string(),
  userId: z.string(),
  reviewerUserId: z.string(),
  reviewNote: z.string(),
  sharedWithPeer: nullSafeOptionalBoolean(),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
})

export const writeSchema = schema.extend({
  updatedAt: firestoreWriteTimestamp,
})

export const empty = Object.freeze(
  schema.parse({
    sectionId: '',
    assignmentId: '',
    roomId: '',
    userId: '',
    reviewerUserId: '',
    reviewNote: '',
    sharedWithPeer: false,
    updatedAt: { seconds: 0, nanoseconds: 0 },
  })
)

export interface FirestoreRoomStateUPRNote extends z.infer<typeof schema> {}
